/* Molten Prints theme — small, dependency-free behaviours.
   Everything degrades: forms post without JS, menus are details/summary. */
(function () {
  'use strict';

  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  /* ---------- Money formatting (mirrors Shopify's money filter) ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var pattern = format || '£{{amount}}';
    function addSeparators(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    var match = pattern.match(placeholder);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount': value = addSeparators(cents, 2); break;
      case 'amount_no_decimals': value = addSeparators(cents, 0); break;
      case 'amount_with_comma_separator': value = addSeparators(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = addSeparators(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = addSeparators(cents, 2, "'", '.'); break;
      default: value = addSeparators(cents, 2);
    }
    return pattern.replace(placeholder, value);
  }

  /* ---------- Header ---------- */
  function initHeader() {
    var toggle = $('[data-menu-toggle]');
    var nav = $('#HeaderNav');
    if (toggle && nav) {
      toggle.addEventListener('click', function () {
        var open = nav.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
    var searchToggle = $('[data-search-toggle]');
    var searchPanel = $('[data-search-panel]');
    if (searchToggle && searchPanel) {
      searchToggle.addEventListener('click', function () {
        var open = searchPanel.classList.toggle('is-open');
        searchToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) { var input = $('input[type="search"]', searchPanel); if (input) input.focus(); }
      });
    }
    // Close dropdowns when clicking elsewhere or pressing Escape.
    document.addEventListener('click', function (e) {
      $$('details[data-details-dropdown][open]').forEach(function (d) {
        if (!d.contains(e.target)) d.removeAttribute('open');
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      $$('details[data-details-dropdown][open]').forEach(function (d) { d.removeAttribute('open'); });
      if (searchPanel && searchPanel.classList.contains('is-open')) { searchPanel.classList.remove('is-open'); searchToggle.setAttribute('aria-expanded', 'false'); searchToggle.focus(); }
    });
  }

  /* ---------- Quantity inputs ---------- */
  function initQuantity() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-quantity-minus], [data-quantity-plus]');
      if (!btn) return;
      var wrap = btn.closest('[data-quantity]');
      var input = $('input', wrap);
      var min = parseInt(input.min || '0', 10);
      var value = parseInt(input.value || '0', 10) || 0;
      value += btn.hasAttribute('data-quantity-plus') ? 1 : -1;
      if (value < min) value = min;
      input.value = value;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* ---------- Cart: submit on quantity change ---------- */
  function initCart() {
    var form = $('[data-cart-form]');
    if (!form) return;
    var timer;
    form.addEventListener('change', function (e) {
      if (!e.target.matches('input[name^="updates"]')) return;
      clearTimeout(timer);
      timer = setTimeout(function () {
        var update = $('[data-cart-update]', form);
        if (update) update.click(); else form.submit();
      }, 350);
    });
  }

  /* ---------- Product form: variants, media, personalisation ---------- */
  function initProductForms() {
    $$('[data-product-form]').forEach(function (root) {
      var dataEl = $('[data-variants]', root);
      if (!dataEl) return;
      var variants = [];
      try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }
      var moneyFormat = root.getAttribute('data-money-format') || '£{{amount}}';
      var idInput = $('select[name="id"], input[name="id"]', root);
      var priceEl = $('[data-price]', root);
      var compareEl = $('[data-compare-price]', root);
      var priceWrap = $('[data-price-wrap]', root);
      var addBtn = $('[data-add-to-cart]', root);
      var addText = $('[data-add-to-cart-text]', root);
      var strings = {
        add: root.getAttribute('data-text-add') || 'Add to basket',
        soldOut: root.getAttribute('data-text-sold-out') || 'Sold out',
        unavailable: root.getAttribute('data-text-unavailable') || 'Unavailable'
      };
      var optionInputs = $$('[data-option-index]', root);
      var optionCount = variants.length && variants[0].options ? variants[0].options.length : 0;

      function selectedOptions() {
        var opts = [];
        for (var i = 0; i < optionCount; i++) {
          var group = optionInputs.filter(function (el) { return parseInt(el.getAttribute('data-option-index'), 10) === i; });
          var value = null;
          group.forEach(function (el) {
            if (el.tagName === 'SELECT') value = el.value;
            else if (el.checked) value = el.value;
          });
          opts.push(value);
        }
        return opts;
      }

      function findVariant(opts) {
        return variants.filter(function (v) {
          return v.options.every(function (o, i) { return o === opts[i]; });
        })[0];
      }

      function updateAvailability(opts) {
        optionInputs.forEach(function (el) {
          if (el.tagName === 'SELECT') return;
          var idx = parseInt(el.getAttribute('data-option-index'), 10);
          var test = opts.slice();
          test[idx] = el.value;
          var exists = variants.some(function (v) {
            return v.available && v.options.every(function (o, i) { return i === idx ? o === el.value : (opts[i] == null || o === opts[i]); });
          });
          var wrap = el.closest('.product__swatch');
          if (wrap) wrap.classList.toggle('is-unavailable', !exists);
        });
      }

      function showMedia(mediaId) {
        if (!mediaId) return;
        var items = $$('[data-media-id]', root.closest('section') || document);
        var target = items.filter(function (el) { return el.getAttribute('data-media-id') === String(mediaId); })[0];
        if (!target) return;
        items.forEach(function (el) { el.classList.toggle('is-active', el === target); });
        $$('[data-thumb]', root.closest('section') || document).forEach(function (t) {
          t.setAttribute('aria-current', t.getAttribute('data-thumb') === String(mediaId) ? 'true' : 'false');
        });
      }

      function render(variant) {
        if (!variant) {
          if (addBtn) { addBtn.disabled = true; }
          if (addText) addText.textContent = strings.unavailable;
          return;
        }
        if (idInput) idInput.value = variant.id;
        if (priceEl) priceEl.textContent = formatMoney(variant.price, moneyFormat);
        if (compareEl) {
          var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
          compareEl.textContent = onSale ? formatMoney(variant.compare_at_price, moneyFormat) : '';
          compareEl.hidden = !onSale;
          if (priceWrap) priceWrap.classList.toggle('price--on-sale', !!onSale);
        }
        if (addBtn) addBtn.disabled = !variant.available;
        if (addText) addText.textContent = variant.available ? strings.add : strings.soldOut;
        if (variant.featured_media) showMedia(variant.featured_media.id);
        $$('[data-selected-value]', root).forEach(function (el) {
          var i = parseInt(el.getAttribute('data-selected-value'), 10);
          el.textContent = variant.options[i] || '';
        });
        if (window.history && history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          history.replaceState({}, '', url.toString());
        }
      }

      optionInputs.forEach(function (el) {
        el.addEventListener('change', function () {
          var opts = selectedOptions();
          updateAvailability(opts);
          render(findVariant(opts));
        });
      });
      if (optionInputs.length) updateAvailability(selectedOptions());

      // Personalisation character counter.
      $$('[data-maxlength-count]', root).forEach(function (field) {
        var out = $('[data-count-for="' + field.id + '"]', root);
        if (!out) return;
        var update = function () { out.textContent = field.value.length + ' / ' + field.maxLength; };
        field.addEventListener('input', update);
        update();
      });
    });

    // Gallery thumbnails.
    document.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-thumb]');
      if (!thumb) return;
      var id = thumb.getAttribute('data-thumb');
      var section = thumb.closest('section') || document;
      $$('[data-media-id]', section).forEach(function (el) { el.classList.toggle('is-active', el.getAttribute('data-media-id') === id); });
      $$('[data-thumb]', section).forEach(function (t) { t.setAttribute('aria-current', t === thumb ? 'true' : 'false'); });
    });
  }

  /* ---------- Collection facets & sort ---------- */
  function initFacets() {
    var form = $('[data-facets-form]');
    if (form) {
      var timer;
      form.addEventListener('change', function () {
        clearTimeout(timer);
        timer = setTimeout(function () { form.submit(); }, 250);
      });
    }
    var sort = $('[data-sort-by]');
    if (sort) {
      sort.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }
    var facetsToggle = $('[data-facets-toggle]');
    var facetsPanel = $('[data-facets-panel]');
    if (facetsToggle && facetsPanel) {
      facetsToggle.addEventListener('click', function () {
        var open = facetsPanel.classList.toggle('is-open');
        facetsToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
  }

  /* ---------- Generic toggles (address forms etc.) ---------- */
  function initToggles() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-toggle-target]');
      if (!btn) return;
      var target = document.getElementById(btn.getAttribute('data-toggle-target'));
      if (!target) return;
      var open = target.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) { var first = $('input, select, textarea', target); if (first) first.focus(); }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initHeader();
    initQuantity();
    initCart();
    initProductForms();
    initFacets();
    initToggles();
  });
  // Shopify theme editor: re-init when sections are reloaded.
  document.addEventListener('shopify:section:load', function () { initProductForms(); });
})();
